import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const negotiationStatus = {
  awaiting_establishment_response: 'Pendente resposta',
  awaiting_client_response: 'Enviado a empresa',
  accepted: 'Efetivado',
  canceled: 'Cancelado',
  rejected: 'Recusado',
  expired: 'Encerrado',
};

export const negotiationStatusOptions = strategyToOptions(negotiationStatus);

export const negotiationProductStatus = {
  pending: 'Pendente',
  accepted: 'Aprovado',
  rejected: 'Recusado',
};

export const negotiationProductValueLabelByStatus = {
  pending: 'Valor desejado',
  accepted: 'Valor negociado',
  rejected: 'Valor recusado',
};

export const negotiationProductValueLabelByAction = {
  counter: 'Valor desejado',
  accept: 'Valor negociado',
  reject: 'Valor recusado',
};
